import { P44Theme, makeP44Styles } from '../../utils/theme';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

// Default color, most likely to be used this way most or all the time, easy to override.
const useStyles = makeP44Styles((theme: P44Theme) => ({
  root: {
    color: theme.palette.teal[600],
  },
}));

const InTransitIcon = (props: SvgIconProps) => {
  const classes = useStyles(props);
  return (
    <SvgIcon classes={{ root: classes.root }} {...props} viewBox="2 2 22 22">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(2.000000, 2.000000)"
          fill="currentColor"
          fillRule="nonzero"
        >
          <path
            d="M12.5428571,13.2571429 C12.245875,13.5404849 11.8131193,13.6292553 11.4285714,13.4857143 C11.0286999,13.3222704 10.7685031,12.9319752 10.7714286,12.5 L10.7714286,11.4285714 C10.7714286,11.2313269 10.6115303,11.0714286 10.4142857,11.0714286 L5.71428571,11.0714286 C5.12255205,11.0714286 4.64285714,10.5917337 4.64285714,10 C4.64285714,9.40826634 5.12255205,8.92857143 5.71428571,8.92857143 L10.3571429,8.92857143 C10.5543874,8.92857143 10.7142857,8.76867312 10.7142857,8.57142857 L10.7142857,7.5 C10.7203333,7.05355787 11.0062085,6.65905008 11.4285714,6.51428571 C11.8292621,6.34580162 12.2920394,6.43609961 12.6,6.74285714 L15.1,9.24285714 C15.5177905,9.66116792 15.5177905,10.3388321 15.1,10.7571429 L12.5428571,13.2571429 Z"
            id="Path"
          ></path>
          <path
            d="M10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 C15.5228475,0 20,4.4771525 20,10 C20,12.6521649 18.9464316,15.195704 17.0710678,17.0710678 C15.195704,18.9464316 12.6521649,20 10,20 Z M10,2.14285714 C5.66061982,2.14285714 2.14285714,5.66061982 2.14285714,10 C2.14285714,14.3393802 5.66061982,17.8571429 10,17.8571429 C14.3393802,17.8571429 17.8571429,14.3393802 17.8571429,10 C17.8492804,5.66388072 14.3361193,2.15071957 10,2.14285714 Z"
            id="Shape"
          ></path>
        </g>
        <rect x="0" y="0" width="24" height="24"></rect>
      </g>
    </SvgIcon>
  );
};

export default InTransitIcon;
